const environments = {
  local: {
    API_URL: "http://10.0.0.50:4242",
  },
  development: {
    API_URL: "https://pii0qnx3n3.execute-api.ap-southeast-2.amazonaws.com/prod",
  },
  uat: {
    API_URL: "https://pii0qnx3n3.execute-api.ap-southeast-2.amazonaws.com/prod",
  },
  production: {
    API_URL: "https://pii0qnx3n3.execute-api.ap-southeast-2.amazonaws.com/prod",
  },
};
const getEnvironmentConfig = () => {
  // For Next.js, we use NEXT_PUBLIC_ prefix for client-side env variables
  const env = process.env.NEXT_PUBLIC_APP_ENV || "development";
  if (!environments[env]) {
    console.warn(`Environment ${env} not found, falling back to development`);
    return environments.development;
  }

  return environments[env].API_URL;
};
const API_URL = getEnvironmentConfig();
export default API_URL;
